import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetCreatedJobs } from '../../models/dashboard/jobs/getCreatedJobs.model';

interface JobCreatedListState {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  jobData: IGetCreatedJobs[];
}

const initialState: JobCreatedListState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
  jobData: [],
};

const jobCreatedListSlice = createSlice({
  name: 'jobsCreatedList',
  initialState,
  reducers: {
    getJobCreatedList(state, action: PayloadAction<JobCreatedListState>) {
      // Replace the state with the new pagination data and jobData array.
      return { ...action.payload };
    },
    removeJob(state, action: PayloadAction<string>) {
      state.jobData = state.jobData.filter((job) => job.id !== action.payload);
    },
    addJob(state, action: PayloadAction<IGetCreatedJobs>) {
      state.jobData.unshift(action.payload);
    },
    editJob(state, action: PayloadAction<IGetCreatedJobs>) {
      const index = state.jobData.findIndex(
        (job) => job.id === action.payload.id
      );
      if (index !== -1) {
        state.jobData[index] = action.payload;
      }
    },
  },
});

export const jobCreatedListActions = jobCreatedListSlice.actions;
export default jobCreatedListSlice.reducer;
